
import { useLocation, useNavigate } from "react-router-dom";
import API from "../services/api";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try { await API.post("/auth/logout"); }
    catch (error) { console.error(error); }
    finally {
      localStorage.removeItem("admin");
      window.location.href = "/";
    }
  };

  const items = [
    ["dashboard", "▦", "Dashboard", "/dashboard"],
    ["clients", "♙", "Clientes", "/clients"],
    ["operators", "♟", "Operadores", "/operators"],
    ["alerts", "◉", "Alertas", "/alerts"],
    ["finances", "$", "Finanzas", "/finances"],
  ];

  const admin = JSON.parse(localStorage.getItem("admin") || "null");
  const initials = (admin?.nombre || "EP").split(" ").map(x => x[0]).slice(0,2).join("").toUpperCase();

  return (
    <>
      <aside className="cc-sidebar">
        <div className="cc-brand">
          <img className="cc-brand-icon" src="/assets/ClinCashLogo.png" alt="" />
          <div className="cc-brand-word"><span>Clin</span><b>Cash</b></div>
        </div>

        <nav className="cc-nav">
          <div className="cc-nav-section">Principal</div>
          {items.map(([key, icon, label, path]) => {
            const active = location.pathname === path || (key === "clients" && location.pathname.startsWith("/client/"));
            return (
              <button key={key} className={`cc-nav-item ${active ? "active" : ""}`} onClick={() => navigate(path)}>
                <span className="cc-nav-icon">{icon}</span>{label}
              </button>
            );
          })}
        </nav>

        <div className="cc-sidebar-bottom">
          <div className="cc-user-mini">
            <div className="cc-avatar">{initials}</div>
            <div style={{ minWidth: 0 }}>
              <div style={{ color: "#fff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {admin?.nombre || "Administrador"}
              </div>
              <div style={{ color: "#89919d", marginTop: 2 }}>Administrador</div>
            </div>
          </div>
          <button className="cc-nav-item" style={{ width: "100%" }} onClick={handleLogout}>
            <span className="cc-nav-icon">↪</span> Cerrar sesión
          </button>
        </div>
      </aside>

    </>
  );
}

export default Header;
